<div class="input-group-text">
  <ng-content></ng-content>
</div>
